import "./InTheNews.scss";

// assets
import newsTimCook_img from "../../../assets/pages/Home/news-tim-cook.png";
import newsUaFunding_img from "../../../assets/pages/Home/news-ua-funding.jpg";
import newsPrimeFunding_img from "../../../assets/pages/Home/news-prime-funding.webp";
import newsAiCommentary_img from "../../../assets/pages/Home/news-ai-commentary.jpg";

// code imports
import React from "react";
import Reveal from "../../common/UI_Elements/Reveal";

// href: add an article link to make the button a real link (until then it renders as a plain button)
const NEWS_ITEMS = [
    {
        img: newsUaFunding_img,
        alt: "Outlook Respawn: Metasports secures $20 million UA funding from Metica",
        tag: "UA FUNDING",
        headline: "Metasports Taps UA Funding Model With",
        highlight: "$20 Million Deal",
        desc: "Metasports secures $20 million UA funding from Metica to scale Hitwicket, improve monetization, and drive global expansion.",
        cta: "Read Full Article",
        href: "https://www.business-standard.com/companies/start-ups/metasports-interactive-raises-20-million-to-fund-user-acquisition-126042701206_1.html",
    },
    {
        img: newsTimCook_img,
        alt: "Tim Cook's tweet about meeting Hitwicket",
        tag: "GLOBAL RECOGNITION",
        headline: "Hitwicket selected as the only game from India to",
        highlight: "meet Tim Cook",
        desc: "A proud moment for Indian gaming. Hitwicket was recognized by Apple CEO Tim Cook for its innovation, impact and global vision.",
        cta: "Read More",
        href: "https://x.com/tim_cook/status/1649329689029394433?s=20",
    },
    {
        img: newsPrimeFunding_img,
        alt: "Hitwicket raises $3 million from Prime Venture Partners",
        tag: "FUNDING",
        headline: "Hitwicket raises $3 million from",
        highlight: "Prime Venture Partners",
        desc: "Hitwicket, a multiplayer cricket gaming app, has raised $3M from Prime Venture Partners to create a strategy-driven gaming studio and deliver ‘world-class cricketing action’ to over a billion cricket lovers globally.",
        cta: "Read Full Article",
        href: "https://www.thehindubusinessline.com/info-tech/hitwicket-raises-3-million-from-prime-venture-partners/article66091944.ece",
    },
    {
        img: newsAiCommentary_img,
        alt: "ETBrandEquity: AI commentary and hyper-personalisation, a new innings for mobile cricket",
        tag: "AI COMMENTARY",
        headline: "Hitwicket creates buzz with",
        highlight: "AI-powered commentary",
        desc: "AI commentary and hyper-personalisation: a new innings for mobile cricket, as covered by ETBrandEquity.",
        cta: "Read Full Article",
        href: "https://brandequity.economictimes.indiatimes.com/news/digital/ai-commentary-and-hyper-personalisation-a-new-innings-for-mobile-cricket/128545137",
    },
];

function NewsCard({ item, delay }) {
    const Cta = item.href ? "a" : "span";
    const ctaProps = item.href ? { href: item.href, target: "_blank", rel: "noopener noreferrer" } : {};

    return (
        <Reveal className="NewsCard" delay={delay}>
            <div className={`NewsCard-media ${item.tilt ? "is-tilted" : ""}`}>
                <img src={item.img} alt={item.alt} loading="lazy" decoding="async" />
                {item.play && <span className="NewsCard-play" aria-hidden="true" />}
            </div>
            <div className="NewsCard-body">
                <span className="NewsCard-tag">{item.tag}</span>
                <h3 className="NewsCard-headline">
                    {item.headline} <span>{item.highlight}</span>
                </h3>
                <p className="NewsCard-desc">{item.desc}</p>
                <Cta className="NewsCard-cta" {...ctaProps}>
                    {item.cta} <span aria-hidden="true">&rarr;</span>
                </Cta>
            </div>
        </Reveal>
    );
}

function InTheNews() {
    return (
        <section className="InTheNews col-12">
            <Reveal className="InTheNews-head">
                <h2>
                    IN THE <span>NEWS</span>
                </h2>
                <p>
                    From global recognition to homegrown impact - Hitwicket continues to make headlines for
                    bringing a new era of cricket gaming.
                </p>
            </Reveal>

            <div className="InTheNews-grid">
                {NEWS_ITEMS.map((item, i) => (
                    <NewsCard key={item.tag} item={item} delay={(i % 2) * 120} />
                ))}
            </div>
        </section>
    );
}

export default InTheNews;
